import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Image,
  Text,
  Box,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react';
import { GroupStandingRow } from '../../types/mundial';
import { SportsCard } from '../ui/SportsCard';
import { useAppColors } from '../../hooks/useAppColors';

interface GroupStandingsTableProps {
  groupId: string;
  standings: GroupStandingRow[];
}

export const GroupStandingsTable: React.FC<GroupStandingsTableProps> = ({
  groupId,
  standings,
}) => {
  const qualifyBg = useColorModeValue('pitch.50', 'pitch.900');
  const thirdBg = useColorModeValue('gold.50', 'rgba(229, 160, 32, 0.15)');
  const { accent } = useAppColors();

  return (
  <SportsCard p={3}>
    <Heading size="sm" mb={3} color={accent}>
      Grupo {groupId}
    </Heading>
    <Box overflowX="auto">
      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            <Th>Pos</Th>
            <Th>Selección</Th>
            <Th isNumeric>PJ</Th>
            <Th isNumeric>G</Th>
            <Th isNumeric>E</Th>
            <Th isNumeric>P</Th>
            <Th isNumeric>GF</Th>
            <Th isNumeric>GC</Th>
            <Th isNumeric>Dif</Th>
            <Th isNumeric>Pts</Th>
          </Tr>
        </Thead>
        <Tbody>
          {standings.map((row) => (
            <Tr
              key={row.teamCode}
              bg={
                row.position <= 2
                  ? qualifyBg
                  : row.position === 3
                  ? thirdBg
                  : undefined
              }
            >
              <Td>{row.position}</Td>
              <Td>
                <Box display="flex" alignItems="center" gap={2}>
                  {row.flagUrl && (
                    <Image
                      src={row.flagUrl}
                      alt={row.teamName}
                      boxSize="24px"
                      borderRadius="sm"
                      objectFit="cover"
                    />
                  )}
                  <Text fontWeight="medium">{row.teamName}</Text>
                </Box>
              </Td>
              <Td isNumeric>{row.played}</Td>
              <Td isNumeric>{row.won}</Td>
              <Td isNumeric>{row.drawn}</Td>
              <Td isNumeric>{row.lost}</Td>
              <Td isNumeric>{row.goalsFor}</Td>
              <Td isNumeric>{row.goalsAgainst}</Td>
              <Td isNumeric>{row.goalDifference}</Td>
              <Td isNumeric fontWeight="bold">
                {row.points}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  </SportsCard>
  );
};
